<div class="p500-ui-form-field">
  <div class="d-flex flex-column">
    <span class="p500-ui-form-field__label mb-4">{{ label }}</span>
    <div>
      <gtd-form-field-image-uploader
        [formControl]="control || innerControl"
        placeholderClass="c-form-field__placeholder_padding-small"
      ></gtd-form-field-image-uploader>
    </div>
  </div>
</div>
